import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

export const OperacionEliminarCubicajeView = ({ silo: { nombreCorto: nombre }, aceptar, cancelar }) => (
  <Grid container spacing={2} direction='column' justify='space-around'>
    <Grid item>
      <Typography variant='h6'>Atención</Typography>
    </Grid>
    <Grid item>
      <Typography variant='h6'>¿Seguro que desea eliminar el último cubicaje de <strong>{nombre}</strong>?</Typography>
    </Grid>
    <Grid container item justify='space-between'>
      <Grid item xs='auto'>
        <Button
          variant='contained'
          onClick={cancelar}
          startIcon={<HighlightOffIcon />}
          color='secondary'>
          Cancelar
        </Button>
      </Grid>
      <Grid item xs='auto'>
        <Button
          variant='contained'
          onClick={aceptar}
          startIcon={<CheckCircleOutlineIcon />}
          color='primary'>
          Aceptar
        </Button>
      </Grid>
    </Grid>
  </Grid>
)
